const LOAD_ACR_OUTAGES = {
  BEGIN: "LOAD_ACR_OUTAGES_BEGIN",
  SUCCESS: "LOAD_ACR_OUTAGES_SUCCESS",
  FAILURE: "LOAD_ACR_OUTAGES_FAILURE"
};

const UPDATE_SELECT_PAGE = "UPDATE_SELECT_PAGE";

const initialState = { outages: [], currentPage: 1, totalPages: 0 };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ACR_OUTAGES.SUCCESS:
      return { ...state, ...action.payload };
    case UPDATE_SELECT_PAGE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const loadAcrOutages = query => {
  return {
    types: [
      LOAD_ACR_OUTAGES.BEGIN,
      LOAD_ACR_OUTAGES.SUCCESS,
      LOAD_ACR_OUTAGES.FAILURE
    ],
    api: api => api.getAcrOutages(query)
  };
};

export const updateSelectedPage = newPage => {
  return {
    type: UPDATE_SELECT_PAGE,
    payload: { currentPage: newPage.value }
  };
};
